import { createFileRoute } from '@tanstack/react-router'
import { PurchaseOrdersPage } from '@/pages/purchase-orders'

export const Route = createFileRoute('/_authenticated/purchase-orders/')({
  staticData: { title: 'Purchase Orders' },
  // The page reads its filters from the URL itself; this only types `stage` for the homepage links.
  validateSearch: (search: Record<string, unknown>) => search as { stage?: string },
  component: PurchaseOrdersPage,
})
